export const languageObject = {
    locale: "en",
    translate: (id: string, parameters?: Record<string, string | number>): string => {
        if (!id) return "";
        const object = (languageObject as any)[languageObject.locale] ?? (languageObject as any).en;
        let translation = object[id] ?? (languageObject as any).en[id] ?? "";
        if (!translation) {
            console.error("Missing translation for '" + id + "'");
            translation = id;
        }
        if (parameters) {
            for (const param in parameters)
                translation = translation.replace("{" + param + "}", parameters[param] + "");
        }
        return translation;
    },
    en: {
        DraftMessagesSectionTitle: "Draft messages",
        SentMessagesSectionTitle: "Sent messages",
        EmptyDraftMessages: "You have no draft messages",
        EmptySentMessages: "You have no sent messages",
        TitleText: "Title",
        PlaceHolderTitle: "Title (required)",
        Recipients: "Recipients",
        Sent: "Sent",
        Send: "Send",
        SendToMe: "Send to me",
        PreviewInThisChannel: "Preview on this channel",
        Edit: "Edit",
        Duplicate: "Duplicate",
        Delete: "Delete",
        EditMessage: "Edit message",
        NewMessage: "New message",
        ViewStatus: "View deliverability",
        SendConfirmation: "Send confirmation",
        PreparingToSend: "Preparing to send...",
        Queued: "Queued...",
        SyncingRecipients: "Syncing recipients...",
        InstallingApp: "Installing app...",
        SendingMessages: "Sending... {SentCount} out of {TotalCount}",
        ImageURL: "Image URL",
        Summary: "Summary",
        Author: "Author",
        Author1: "- Author",
        Previous: "Previous",
        Next: "Next",
        SendHeadingText: "Choose how you want to send your message",
        SendToGeneralChannel: "Send to the General channel of a specific teams",
        SentToGeneralChannel: "Sent to the General channel of the following teams",
        SendToGeneralChannelPlaceHolder: "Select team(s)",
        NoMatchMessage: "We couldn't find any matches",
        SendToRosters: "Send as a chat message to the following Teams's members",
        SentToRosters: "Sent to everybody's chat in Teams",
        SendToRostersPlaceHolder: "Choose team(s) members",
        SendToGroups: "Send as a chat message of the following M365 groups, Distribution groups or Security groups's members",
        SendToGroupsPlaceHolder: "Type the name or email address of the group(s)",
        SendToGroupsNote: "Note: This option sends the message to all the members of the group who have access to the app.",
        SendToGroupsPermissionNote: "Permissions needed. Please, ask your IT admin to enable this option for you.",
        LoadingText: "Loading...",
        SentToGroups1: "Sent as a chat message to the following groups's members",
        SentToGroups2: "M365 groups, Distribution groups or Security groups",
        SendToAllUsers: "Send as a chat message to everyone",
        SendToAllUsersNote: "Note: This option sends the message to all the users in the organization who have access to the app.",
        Back: "Back",
        SaveAsDraft: "Save as draft",
        ConfirmToSend: "Are you sure you want to send this message?",
        SendToRecipientsLabel: "Send to the following recipients:",
        TeamsLabel: "Team(s): ",
        TeamsMembersLabel: "Team(s) members: ",
        GroupsMembersLabel: "Group(s) members: ",
        PreparingMessageLabel: "Preparing message",
        ExportLabel: "exporting",
        CloseText: "Close",
        AllUsersLabel: "All users",
        SendingStarted: "Started",
        SendingCompleted: "Completed",
        Duration: "Duration",
        Results: "Results",
        Success: "Delivered to {SuccessCount} user(s)",
        Failure: "Not sent to {FailureCount} user(s)",
        Unknown: "Unknown status: {UnknownCount}",
        Throttled: "Throttled : ",
        TooltipSuccess: "Delivered",
        TooltipFailure: "Not sent",
        TooltipUnknown: "Unknown status",
        TooltipThrottled: "Throttled",
        TooltipViews: "Views",
        Errors: "Errors",
        Warnings: "Warnings",
        SignInPromptMessage: "Please sign in to continue.",
        SignIn: "Sign in",
        UnauthorizedErrorMessage: "Sorry, an error occurred while trying to access this service.",
        ForbiddenErrorMessage: "Sorry, you do not have permission to access this page. Please get in touch with your administrator to get permission.",
        GeneralErrorMessage: "Ooops! An unexpected error occurred. Try refreshing the page, or contact your administrator if the problem persists.",
        ExportQueueTitle: "Your export is queued",
        ExportQueueSuccessMessage1: "You'll be notified in chat when your file is ready to download.",
        ExportQueueSuccessMessage2: "Note: You will first get a chat message asking you to give this app permission to upload to your OneDrive.",
        ExportQueueSuccessMessage3: "Select \"Allow\" to proceed.",
        ExportErrorTitle: "Something went wrong...",
        ExportErrorMessage: "Try exporting the results again. If the problem persists, contact your IT admin for help.",
        ExportButtonText: "Export detailed results",
        ExportButtonProgressText: "Export in progress",
        ErrorURLMessage: "URL must start with https://",
        Topics: "Topics",
        TopicManagement: "Topic management",
        AddTopic: "Add topic",
        NewTopic: "New topic",
        CreateNewTopic: "Create a new topic",
        FieldRequired: "This field is required",
        Description: "Description",
        ActivatedAllUsersDefault: "Activated to all users by default",
        CannotDeactivate: "Cannot be deactivated",
        Translations: "Translations",
        Language: "Language",
        ChooseLanguage: "Choose a language",
        AddTranslation: "Add translation",
        Remove: "Remove",
        English: "English",
        French: "French",
        German: "German",
        Spanish: "Spanish",
        Portuguese: "Portuguese",
        Italian: "Italian",
        Chinese: "Chinese",
        Japanese: "Japanese",
        Polish: "Polish",
        Czech: "Czech",
        Russian: "Russian",
        Cancel: "Cancel",
        Save: "Save",
        MessageManagement: "Message management",
        UnsavedChanges: "Unsaved changes",
        DiscardEdits: "Do you want to discard edits or continue editing?",
        Configuration: "Configuration",
        CreateMessage: "Create the message",
        AddLanguageTranslation: "Add the {Language} translation",
        ChooseAudience: "Choose the audience",
        MessageConfiguration: "Message configuration",
        DefaultLanguage: "Default language",
        AdditionalLanguages: "Additional languages",
        MessageCreation: "Message creation",
        WriteMessage: "Write your message",
        WriteMessageIn: "Write your message in {Language}",
        MessageType: "Message type",
        AskUserFeedback: "Ask user for feedback",
        GiveUsFeedback: "Give us a feedback",
        AddButton: "Add button",
        Button: "Button",
        TellUsWhatYouThink: "Tell us what you think",
        SendFeedback: "Send feedback",
        UpdateTopic: "Update a topic",
        Deleting: "Deleting",
        EmptyTopics: "You have no topics.",
        RemoveTopic: "Remove topic",
        ConfirmRemoveTopic: "Are you sure to delete this topic?",
        MustSelectOneTopic: "You must select at least one topic",
        MustSelectGpt: "You must select an Agent",
        Confirm: "Confirm",
        TopicLinked: "This topic is linked to messages",
        PreviewMessage: "Preview message",
        SelectPreviewLanguage: "Select the language you would like to preview",
        Status: "Deliverability",
        Impact: "Open rate",
        Languages: "Languages",
        SendTo: "Send to",
        SentMessages: "Sent messages",
        ReadMessages: "Read messages",
        ReceivedFeedbacks: "Feedback received",
        ButtonsStats: "Buttons statistics",
        ExportFeedbacks: "Export feedback",
        NoAdditionalLanguage: "No additional language",
        NumberOfClicks: "Number of clicks",
        NoAvailableButton: "No available button",
        MessageInProgress: "Message in progress",
        Unavailable: "Unavailable",
        Audience: "Audience",
        ChangeNotificationSettings: "Change your notification settings",
        SelectFavoriteLanguage: "Select your favorite communication language",
        SelectInterestingTopic: "Select your preferred topics",
        NotificationFeedbacks: "Feedback notification",
        UserName: "User name",
        UserUPN: "User UPN",
        UserLanguage: "User language",
        Feedback: "Feedback",
        Feedbacks: "Reply rate",
        Date: "Date",
        NoAvailableFeedback: "No feedback available",
        PreviewSent: "Preview has been sent",
        PreviewError: "Preview can't be sent",
        UserSettingsFavoriteLanguageMessage: "If the message is not translated, it will be displayed in English by default",
        RemoveMessage: "Remove message",
        ConfirmRemoveMessage: "Are you sure to delete this message?",
        Settings: "Settings",
        Gallery: "Gallery",
        Welcome: "Welcome",
        GalleryManagement: "Gallery management",
        UploadImage: "Upload image",
        NewFolder: "New folder",
        MyImages: "My images",
        Name: "Name",
        SelectImage: "Select image",
        Image: "Image",
        InvalidImage: "Invalid image",
        ImagePreview: "Image preview",
        Size: "Size",
        Extension: "Extension",
        CantUploadImage: "The image can't be uploaded",
        NoImage: "No image available",
        Location: "Location",
        SelectFolder: "Select a folder",
        PleaseSelectFolder: "Please select a folder",
        YouHaveSelectedFolder: "You have selected the folder",
        FolderName: "Folder name",
        NewSubFolder: "New subfolder",
        NoFolder: "No folder",
        RenameFolder: "Rename folder",
        DeleteImage: "Delete image",
        ConfirmDeleteImage: "Are you sure to delete this image?",
        ImageName: "Image name",
        Add: "Add",
        Select: "Select",
        Format: "Format",
        MaxSize: "Max size",
        PleaseSelectOtherName: "Please select an other name",
        CropImage: "Crop image",
        Crop: "Crop",
        Zoom: "Zoom",
        Rotation: "Rotation",
        AspectRatio: "Aspect ratio",
        Reset: "Reset",
        FolderOptions: "Folder options",
        Rename: "Rename",
        DeleteFolder: "Delete folder",
        AreYouSureDeleteFolder: "Are you sure to delete this folder?",
        ConfigMessage: "Please click Save to get started.",
        WelcomeMessage: "Welcome message",
        Title: "Title",
        Message: "Message",
        Browse: "Browse",
        PleaseSelectImage: "Please select an image",
        YouHaveSelectedImage: "You have selected image",
        Paragraph: "Paragraph",
        Actions: "Click rate",
        WelcomeMessageApp: "Welcome to Company Communicator Pro",
        WelcomeSubtitle: "Broadcast your internal communications in Microsoft Teams with Company Communicator Pro",
        AllGoodMessage: "All good, please click Save to continue",
        LestGoButton: "Let's go 🚀",
        MessageConfigurationApp: "Everything is set up",
        MessageConfigurationSubtitle: "Click Save to continue",
        ArchiverMessagesSectionTitle: "Archived messages",
        NotReadMessages: "Unread messages",
        ButtonUsageTitle: "Button usage",
        MessageOrgOnly: "Everybody with access to Company Communicator Pro - Author version will view these messages",
        TopicsOrgOnly: "Everybody with access to Company Communicator Pro - Author version will view these topics",
        NotReceivedFeedbacks: "No feedback received",
        Move: "Move",
        MoveImage: "Move image",
        FailedMessage: "This message has failed",
        FeedBackNoConfigured: "Feedbacks are not configured on this message",
        Link: "Link",
        HomeProWorkplaceMessage: "Home Pro for Microsoft Teams: your documents, apps and teams close at hand.",
        DisplayMessageHomePro: "Display message on Home Pro (Soon available)",
        DisplayMessageUntil: "Display the message until",
        HomeProWebsiteLink: "https://www.teams-pro.com/en/browse-apps/home-pro/?utm_source=company_communicator_pro&utm_medium=teams&utm_campaign=display_message_home_pro",
        ReadMore: "Read more",
        ImageAlreadyExistingWithThisName: "An image already has this name",
        NoDataAvailable: "No data available",
        AvailableCharsFolderName: "Only alphanumeric characters, spaces and dashes are allowed",
        Folder: "Folder",
        SelectParentFolder: "Select parent folder",
        FolderAlreadyExistingWithThisName: "A folder already has this name",
        AnErrorOccured: "An error occured",
        NeedToConsent: "You need to consent",
        ClickButtonToContinue: "Click on the button to continue",
        Consent: "Consent",
        CancelledByUser: "You need to consent app before using it",
        SignOut: "Sign out",
        Ready: "Ready",
        InitializationInProgress: "Initialization in progress",
        Images: "Images",
        LoadingMessages: "Loading messages",
        State: "State",
        SentDate: "Sent date",
        ViewDetails: "View details",
        CharacterLimitReached: "The character limit has been reached",
        Close: "Close",
        Discard: "Discard",
        FailedToSend: "Failed to send",
        GenerateMessage: "Generate message",
        Tone: "Tone",
        Length: "Length",
        Celebratory: "Celebratory",
        Neutral: "Neutral",
        Serious: "Serious",
        Short: "Short",
        Medium: "Medium",
        Long: "Long",
        Generate: "Generate",
        Suggestions: "Suggestions",
        Warning: "Warning",
        Instruction: "Instruction",
        GenerationInProgress: "Generation in progress",
        WriteSubjectOfMessage: "Write the context of the message",
        SuggestionsFoundByCopilot: "Suggestions found by Copilot",
        ImagesUnderCreativeCommonLicense: "Images under Creative Common license",
        MessageSubject: "Context overview",
        SuggestionsRightsMessage: "You are responsilble for respecting others right, including copyright.",
        LearnMoreHere: "Learn more here",
        PoweredByBing: "Powered by Bing",
        Keywords: "Keywords",
        GenerateByCopilot: "Create with Copilot",
        Channel: "Channel",
        Channel_Teams: "Teams",
        Channel_Windows: "Windows",
        Channel_GPTPro: "AI desk PRO",
        Gpt: "Agent",
        MailingLists: "Mailing lists",
        ImportList: "Import list",
        ManagementOfMailingLists: "Management of mailing lists",
        ImportYourMailingList: "Import your mailing list",
        PleaseSelectAnExcelFile: "Please select an Excel file",
        DownloadTemplate: "Download template",
        SelectAFile: "Select a file",
        CheckingImportedUsers: "Checking imported users",
        PleaseWaitAMoment: "Please wait a moment",
        OneUserImportedWithSuccess: "1 user imported with success",
        CountUsersImportedWithSuccess: "{count} users imported with success",
        GiveANameToYourMailingList: "Give a name to your mailing list",
        EnterListName: "Enter list name",
        CountUser: "{count} user",
        CountUsers: "{count} users",
        EmptyLists: "You have no lists.",
        RemoveMailingList: "Remove mailing list",
        ConfirmRemoveMailingList: "Are you sure to delete this mailing list?",
        UpdateMailingList: "Update a mailing list",
        Users: "Users",
        SearchUpn: "Search UPN",
        Email: "Email",
        Emails: "Emails",
        AddUpn: "Add UPN",
        DeleteSelectedEmail: "Delete 1 email",
        DeleteCountEmails: "Delete {count} emails",
        EnterEmailAddress: "Enter email address",
        TypeAReply: "Type a reply",
        Reply: "Reply",
        SendToMailingList: "Send to mailing list",
        SelectMailingList: "Select mailing list",
        Banner: "Banner",
        PowershellScript: "Powershell script",
        URL: "URL",
        Action: "Action",
        SelectScript: "Select script",
        DisabledCommingSoon: "Comming soon",
        Filters: "Filters",
        GPT: "Agent",
        ExportData: "Export data",
        NoMessage: "No message",
        ResendToUnread: "Resend to unread",
        PrepareResending: "Prepare resending",
        SubMessage: "Sub message",
        DelayedDispatch: "Delayed dispatch",
        Planned: "Planned",
        NoTopics: "No topics",
        MsTeams: "Teams",
        Windows: "Windows",
        GPTPro: "AI desk PRO",
        ButtonURL: "Button URL",
        ButtonTitle: "Button title",
        MessageSent: "Message sent",
    },
    fr: {
        DraftMessagesSectionTitle: "Brouillons",
        SentMessagesSectionTitle: "Messages envoyés",
        EmptyDraftMessages: "Aucun brouillon",
        EmptySentMessages: "Aucun message envoyé",
        TitleText: "Titre",
        PlaceHolderTitle: "Titre (obligatoire)",
        Recipients: "Destinataires",
        Sent: "Envoyé",
        Send: "Envoyer",
        SendToMe: "Envoyer à moi seul",
        PreviewInThisChannel: "Aperçu dans ce canal",
        Edit: "Modifier",
        Duplicate: "Dupliquer",
        Delete: "Supprimer",
        EditMessage: "Modifier le message",
        NewMessage: "Nouveau message",
        ViewStatus: "Afficher l’état",
        SendConfirmation: "Envoyer la confirmation",
        PreparingToSend: "Préparation de l'envoi...",
        Queued: "Mise en file d’attente...",
        SyncingRecipients: "Synchronisation en cours des destinataires...",
        InstallingApp: "Installation en cours de l’application...",
        SendingMessages: "Envoi... {SentCount} sur {TotalCount}",
        ImageURL: "URL de l'image",
        Summary: "Récapitulatif",
        Author: "Auteur",
        Author1: "- Auteur",
        Previous: "Précédent",
        Next: "Suivant",
        SendHeadingText: "Choisissez la manière dont vous voulez envoyer votre message",
        SendToGeneralChannel: "Envoyer au canal général d’équipes spécifiques",
        SentToGeneralChannel: "Envoyé au canal général des équipes suivantes",
        SendToGeneralChannelPlaceHolder: "Sélectionner une ou des équipes",
        NoMatchMessage: "Nous n'avons trouvé aucun résultat correspondant.",
        SendToRosters: "Envoyer en conversation aux membres des équipes suivantes",
        SentToRosters: "Envoyé dans la conversation à des personnes dans Teams",
        SendToRostersPlaceHolder: "Choisir le(s) membre(s) de l’équipe",
        SendToGroups: "Envoyer en conversation aux membres des groupes M365 suivants, des groupes de distribution ou des groupes de sécurité",
        SendToGroupsPlaceHolder: "Tapez le nom ou l’adresse de courrier du ou des groupes",
        SendToGroupsNote: "Remarque : cette option envoie le message à tous les membres du groupe qui ont accès à l’application utilisateur.",
        SendToGroupsPermissionNote: "Autorisations nécessaires. Demandez à votre administrateur informatique d’activer cette option pour vous.",
        LoadingText: "Chargement en cours…",
        SentToGroups1: "Envoyé en conversation aux membres des groupes suivants",
        SentToGroups2: "Groupes M365, groupes de distribution ou groupes de sécurité",
        SendToAllUsers: "Envoyer dans la conversation à tout le monde",
        SendToAllUsersNote: "Remarque : cette option envoie le message à tous les utilisateurs de l’organisation qui ont accès à l’application utilisateur.",
        Back: "Précédent",
        SaveAsDraft: "Enregistrer comme brouillon",
        ConfirmToSend: "Envoyer ce message ?",
        SendToRecipientsLabel: "Envoyer aux destinataires suivants :",
        TeamsLabel: "Équipe(s) : ",
        TeamsMembersLabel: "Membre(s) de l’équipe : ",
        GroupsMembersLabel: "Membres du ou des groupes : ",
        PreparingMessageLabel: "préparation du message",
        ExportLabel: "exportation",
        CloseText: "Fermer",
        AllUsersLabel: "Tous les utilisateurs",
        SendingStarted: "Début",
        SendingCompleted: "Fin",
        Duration: "Durée",
        Results: "Résultats",
        Success: "Réussite: {SuccessCount}",
        Failure: "Échec: {FailureCount}",
        Unknown: "Inconnu: {UnknownCount}",
        Throttled: "Limité: ",
        TooltipSuccess: "Réussite",
        TooltipFailure: "Échec",
        TooltipUnknown: "Inconnu",
        TooltipThrottled: "Limité",
        TooltipViews: "Vus",
        Errors: "Erreurs",
        Warnings: "Avertissements",
        SignInPromptMessage: "Merci de vous connecter pour continuer.",
        SignIn: "Se connecter",
        UnauthorizedErrorMessage: "Désolé, une erreur s’est produite lors de la tentative d’accès à ce service.",
        ForbiddenErrorMessage: "Désolé, vous n’êtes pas autorisé à accéder à cette page. Contactez votre administrateur pour qu’il vous accorde l’autorisation.",
        GeneralErrorMessage: "Désolé. Une erreur inattendue semble s’être produite. Pourquoi ne pas essayer d’actualiser votre page ? Vous pouvez également contacter votre administrateur si le problème persiste.",
        ExportQueueTitle: "Votre exportation est mise en file d’attente",
        ExportQueueSuccessMessage1: "Vous serez averti dans la conversation lorsque votre fichier sera prêt à être téléchargé.",
        ExportQueueSuccessMessage2: "Remarque : vous allez d’abord recevoir un message de conversation vous invitant à donner à cette application l’autorisation de télécharger sur votre OneDrive.",
        ExportQueueSuccessMessage3: "Sélectionnez « Autoriser » pour continuer.",
        ExportErrorTitle: "Désolé... Nous avons rencontré un problème.",
        ExportErrorMessage: "Réessayez d’exporter les résultats. Si le problème persiste, contactez votre administrateur informatique pour obtenir de l’aide.",
        ExportButtonText: "Exporter les résultats détaillés",
        ExportButtonProgressText: "L’exportation est en cours... Merci de patienter.",
        ErrorURLMessage: "L'URL doit commencer par https://",
        Topics: "Sujets",
        TopicManagement: "Gestion des sujets",
        AddTopic: "Ajouter un sujet",
        NewTopic: "Nouveau sujet",
        CreateNewTopic: "Créer un nouveau sujet",
        FieldRequired: "Ce champ est requis",
        Description: "Description",
        ActivatedAllUsersDefault: "Activé pour tous les utilisateurs par défaut",
        CannotDeactivate: "Ne peut pas être désactivé",
        Translations: "Traductions",
        Language: "Langue",
        ChooseLanguage: "Choisir une langue",
        AddTranslation: "Ajouter une traduction",
        Remove: "Supprimer",
        English: "Anglais",
        French: "Français",
        German: "Allemand",
        Spanish: "Espagnol",
        Portuguese: "Portuguais",
        Italian: "Italien",
        Chinese: "Chinois",
        Japanese: "Japonais",
        Polish: "Polonais",
        Czech: "Tchèque",
        Russian: "Russe",
        Cancel: "Annuler",
        Save: "Sauvegarder",
        MessageManagement: "Gestion des messages",
        UnsavedChanges: "Annuler les modifications",
        DiscardEdits: "Souhaitez-vous annuler les modifications ?",
        Configuration: "Configuration",
        CreateMessage: "Créer le message",
        AddLanguageTranslation: "Ajouter la traduction en {Language}",
        ChooseAudience: "Choisir le public",
        MessageConfiguration: "Configuration du message",
        DefaultLanguage: "Langue par défaut",
        AdditionalLanguages: "Langues supplémentaires",
        MessageCreation: "Création du message",
        WriteMessage: "Écrivez le message",
        WriteMessageIn: "Écrivez le message en {Language}",
        MessageType: "Type de message",
        AskUserFeedback: "Demander un avis à l'utilisateur",
        GiveUsFeedback: "Donnez-nous votre avis",
        AddButton: "Ajouter un bouton",
        Button: "Bouton",
        TellUsWhatYouThink: "Dites-nous ce que vous en pensez",
        SendFeedback: "Envoyer l'avis",
        UpdateTopic: "Mettre à jour un sujet",
        Deleting: "Suppression",
        EmptyTopics: "Aucun sujet",
        RemoveTopic: "Supprimer le sujet",
        ConfirmRemoveTopic: "Êtes-vous certain de vouloir supprimer ce sujet ?",
        MustSelectOneTopic: "Vous devez sélectionner au minimum un sujet",
        MustSelectGpt: "Vous devez sélectionner un Agent",
        Confirm: "Valider",
        TopicLinked: "Le sujet est relié à d'autres messages",
        PreviewMessage: "Aperçu du message",
        SelectPreviewLanguage: "Sélectionnez la langue avec laquelle vous voulez voir l'aperçu",
        Status: "Délivrabilité",
        Impact: "Visibilité",
        Languages: "Langues",
        SendTo: "Envoyé à",
        SentMessages: "Messages envoyés",
        ReadMessages: "Messages lus",
        ReceivedFeedbacks: "Avis reçus",
        ButtonsStats: "Statistiques des boutons",
        ExportFeedbacks: "Exporter les avis",
        NoAdditionalLanguage: "Aucune langue supplémentaire",
        NumberOfClicks: "Nombre de clics",
        NoAvailableButton: "Aucun bouton disponible",
        MessageInProgress: "Message en cours de distribution",
        Unavailable: "Indisponible",
        Audience: "Audience",
        ChangeNotificationSettings: "Modifier les paramètres de notification",
        SelectFavoriteLanguage: "Sélectionnez votre langue de communication favorite",
        SelectInterestingTopic: "Sélectionnez les sujets qui vous intéressent",
        NotificationFeedbacks: "Avis du message",
        UserName: "Utilisateur",
        UserUPN: "Identifiant UPN",
        UserLanguage: "Langue",
        Feedback: "Avis",
        Feedbacks: "Retours",
        Date: "Date",
        NoAvailableFeedback: "Aucun avis disponible",
        PreviewSent: "L'aperçu a été envoyé",
        PreviewError: "L'aperçu n'a pas pu être envoyé",
        UserSettingsFavoriteLanguageMessage: "Si le message n'est pas traduit dans votre langue favorite, il sera affiché en anglais par défaut",
        RemoveMessage: "Supprimer le message",
        ConfirmRemoveMessage: "Êtes-vous certain de vouloir supprimer ce message ?",
        Settings: "Paramètres",
        Gallery: "Galerie",
        Welcome: "Bienvenue",
        GalleryManagement: "Gestion de la galerie",
        UploadImage: "Ajouter une image",
        NewFolder: "Nouveau dossier",
        MyImages: "Mes images",
        Name: "Nom",
        SelectImage: "Sélectionner une image",
        Image: "Image",
        InvalidImage: "Image invalide",
        ImagePreview: "Aperçu de l'image",
        Size: "Taille",
        Extension: "Extension",
        CantUploadImage: "L'image n'a pas pu être uploadée",
        NoImage: "Aucune image disponible",
        Location: "Emplacement",
        SelectFolder: "Sélectionner un dossier",
        PleaseSelectFolder: "Veuillez sélectionner un dossier",
        YouHaveSelectedFolder: "Vous avez sélectionné le dossier",
        FolderName: "Nom du dossier",
        NewSubFolder: "Nouveau sous-dossier",
        NoFolder: "Aucun dossier",
        RenameFolder: "Renommer le dossier",
        DeleteImage: "Supprimer une image",
        ConfirmDeleteImage: "Êtes-vous certain de vouloir supprimer cette image ?",
        ImageName: "Nom de l'image",
        Add: "Ajouter",
        Select: "Sélectionner",
        Format: "Format",
        MaxSize: "Taille maximale",
        PleaseSelectOtherName: "Veuillez choisir un autre nom",
        CropImage: "Rogner l'image",
        Crop: "Rogner",
        Zoom: "Zoom",
        Rotation: "Rotation",
        AspectRatio: "Ratio d'aspect",
        Reset: "Réinitialiser",
        FolderOptions: "Folder options",
        Rename: "Renommer",
        DeleteFolder: "Supprimer le dossier",
        AreYouSureDeleteFolder: "Êtes-vous certain de vouloir supprimer ce dossier ?",
        ConfigMessage: "Veuillez cliquer sur sauvegarder afin de continuer.",
        WelcomeMessage: "Message de bienvenue",
        Title: "Titre",
        Message: "Message",
        Browse: "Parcourir",
        PleaseSelectImage: "Veuillez sélectionner une image",
        YouHaveSelectedImage: "Vous avez sélectionné l'image",
        Paragraph: "Paragraphe",
        Actions: "Taux de clics",
        WelcomeMessageApp: "Bienvenue dans Company Communicator Pro",
        WelcomeSubtitle: "Diffusez vos communications internes dans Microsoft Teams avec Company Communicator Pro",
        AllGoodMessage: "Tout est bon, veuillez cliquer sur Enregistrer pour continuer",
        LestGoButton: "C'est parti 🚀",
        MessageConfigurationApp: "Tout est prêt",
        MessageConfigurationSubtitle: "Cliquez sur Enregistrer pour continuer",
        ArchiverMessagesSectionTitle: "Archiver messages",
        NotReadMessages: "Messages non lus",
        ButtonUsageTitle: "Utilisation des boutons",
        MessageOrgOnly: "Tous les messages créés ne seront visibles que par votre organisation.",
        TopicsOrgOnly: "Tous les sujets créés ne seront visibles que par votre organisation.",
        NotReceivedFeedbacks: "Commentaires non reçus",
        Move: "Déplacer",
        MoveImage: "Déplacer l'image",
        Link: "Lien",
        FailedMessage: "Ce message a échoué",
        FeedBackNoConfigured: "Les avis ne sont pas configurés pour ce message",
        HomeProWorkplaceMessage: "Home Pro pour Microsoft Teams : vos documents, applications et équipes à portée de main.",
        DisplayMessageHomePro: "Afficher le message dans Home Pro (Bientôt disponible)",
        DisplayMessageUntil: "Afficher le message jusqu'à",
        HomeProWebsiteLink: "https://www.teams-pro.com/fr/parcourir-applications/home-pro/?utm_source=company_communicator_pro&utm_medium=teams&utm_campaign=display_message_home_pro",
        ReadMore: "En savoir plus",
        ImageAlreadyExistingWithThisName: "Une image porte déjà ce nom",
        NoDataAvailable: "Aucune donnée disponible",
        AvailableCharsFolderName: "Seuls les caractères alphanumériques, les espaces et tirets sont autorisés",
        Folder: "Dossier",
        SelectParentFolder: "Sélectionner le dossier parent",
        FolderAlreadyExistingWithThisName: "Un dossier porte déjà ce nom",
        AnErrorOccured: "Une erreur s'est produite",
        NeedToConsent: "Vous devez donner votre accord",
        ClickButtonToContinue: "Cliquez sur le bouton pour continuer",
        Consent: "Consentir",
        CancelledByUser: "Vous devez consentir aux droits demandés par l'application afin de pouvoir l'utiliser",
        SignOut: "Se déconnecter",
        Ready: "Prêt",
        InitializationInProgress: "Initialisation en cours",
        Images: "Images",
        LoadingMessages: "Chargement des messages",
        State: "Statut",
        SentDate: "Date d'envoi",
        ViewDetails: "Voir les détails",
        CharacterLimitReached: "La limite de caractères est atteinte",
        Close: "Fermer",
        Discard: "Annuler",
        FailedToSend: "Échec d'envoi",
        GenerateMessage: "Générer le message",
        Tone: "Tonalité",
        Length: "Longueur",
        Celebratory: "Célébration",
        Neutral: "Neutre",
        Serious: "Sérieux",
        Short: "Court",
        Medium: "Moyen",
        Long: "Long",
        Generate: "Générer",
        Suggestions: "Suggestions",
        Warning: "Danger",
        Instruction: "Instruction",
        GenerationInProgress: "Génération en cours",
        WriteSubjectOfMessage: "Veuillez saisir le contexte du message",
        SuggestionsFoundByCopilot: "Suggestions trouvées par Copilot",
        ImagesUnderCreativeCommonLicense: "Images sous licence Creative Common",
        MessageSubject: "Contexte du message",
        SuggestionsRightsMessage: "Vous êtes responsable du respect des droits d'autrui, y compris des droits d'auteur.",
        LearnMoreHere: "En savoir plus",
        PoweredByBing: "Propulsé par Bing",
        Keywords: "Mots clés",
        GenerateByCopilot: "Créez avec Copilot",
        Channel: "Canal",
        Channel_Teams: "Teams",
        Channel_Windows: "Windows",
        Channel_GPTPro: "AI desk PRO",
        Gpt: "Agent",
        MailingLists: "Listes de diffusion",
        ImportList: "Importer une liste",
        ManagementOfMailingLists: "Gestion des listes de diffusion",
        ImportYourMailingList: "Importez votre liste de diffusion",
        PleaseSelectAnExcelFile: "Veuillez sélectionner un fichier Excel",
        DownloadTemplate: "Télécharger le modèle",
        SelectAFile: "Sélectionner un fichier",
        CheckingImportedUsers: "Vérification des utilisateurs importés",
        PleaseWaitAMoment: "Veuillez patienter un instant",
        OneUserImportedWithSuccess: "1 utilisateur importé avec succès",
        CountUsersImportedWithSuccess: "{count} utilisateurs importés avec succès",
        GiveANameToYourMailingList: "Donnez un nom à votre liste de diffusion",
        EnterListName: "Saisir le nom de la liste",
        CountUser: "{count} utilisateur",
        CountUsers: "{count} utilisateurs",
        EmptyLists: "Vous n'avez aucune liste.",
        RemoveMailingList: "Supprimer la liste de diffusion",
        ConfirmRemoveMailingList: "Êtes-vous certain de vouloir supprimer cette liste de diffusion ?",
        UpdateMailingList: "Mettre à jour une liste de diffusion",
        Users: "Utilisateurs",
        SearchUpn: "Rechercher un UPN",
        Email: "Email",
        Emails: "Emails",
        AddUpn: "Ajouter un UPN",
        DeleteSelectedEmail: "Supprimer 1 email",
        DeleteCountEmails: "Supprimer {count} emails",
        EnterEmailAddress: "Saisir l'adresse email",
        TypeAReply: "Saisir une réponse",
        Reply: "Répondre",
        SendToMailingList: "Envoyer à la liste de diffusion",
        SelectMailingList: "Sélectionner une liste de diffusion",
        Banner: "Bannière",
        ButtonAction: "Action du bouton",
        PowershellScript: "Script Powershell",
        URL: "URL",
        Action: "Action",
        SelectScript: "Sélectionner un script",
        DisabledCommingSoon: "Bientôt disponible",
        Filters: "Filtres",
        GPT: "Agent",
        ExportData: "Exporter les données",
        NoMessage: "Aucun message",
        ResendToUnread: "Renvoyer aux non lus",
        PrepareResending: "Préparation du renvoi",
        SubMessage: "Message secondaire",
        DelayedDispatch: "Envoi planifié",
        Planned: "Planifié",
        NoTopics: "Aucun sujet",
        MsTeams: "Teams",
        Windows: "Windows",
        GPTPro: "AI desk PRO",
        ButtonURL: "URL du bouton",
        ButtonTitle: "Titre du bouton",
        MessageSent: "Message envoyé",
    }
}

export default languageObject;